class PendoUtils {
  static setDataToLS(analytics) {
    const newItem = {
      analytics,
      timestamp: new Date().toISOString()
    };

    localStorage.setItem('sm-account-data', JSON.stringify(newItem));
  }

  static sendDataToPendo(data) {
    // This function creates visitors and accounts in Pendo
    // You will need to replace <visitor-id-goes-here> and <account-id-goes-here> with values you use in your app
    // Please use Strings, Numbers, or Bools for value types.
    data['visitor']['screenWidth'] = window.innerWidth;
    data['visitor']['screenHeight'] = window.innerHeight;
    pendo.initialize(data);
  }

  static fetchAccountData() {
    fetch('/analytics_account_data')
      .then(FetchUtils.checkResponseStatus)
      .then(response => response.json())
      .then(data => {
        PendoUtils.setDataToLS(data);
        PendoUtils.sendDataToPendo(data);
      }).catch(err => FetchUtils.handleResponseError(err));
  }

  static track(event, metadata = {}) {
    if (window.pendo && typeof window.pendo.track === 'function') {
      window.pendo.track(event, metadata);
    }
  }

  // Pendo buffers track events and only sends them on a ~5 minute timer or on
  // page unload (via an async XHR that the browser cancels on reload). When a
  // tracked action is immediately followed by navigation, force the queue to
  // flush so the event actually reaches Pendo.
  static flush() {
    if (window.pendo && typeof window.pendo.flushNow === 'function') {
      window.pendo.flushNow();
    }
  }

  static initWithAccountData() {
    const accountDataStr = localStorage.getItem('sm-account-data');

    if (accountDataStr) {
      const accountData = JSON.parse(accountDataStr);
      const itemTime = new Date(accountData.timestamp);
      const diffHours = (new Date() - itemTime) / (1000 * 60 * 60);
      if (diffHours < 24) {
        PendoUtils.sendDataToPendo(accountData.analytics);
      } else {
        PendoUtils.fetchAccountData();
      }
    } else {
      PendoUtils.fetchAccountData();
    }
  }
}

export default PendoUtils;
